import type { QuoteRequestStatus } from '@repo/api-contracts';

export const QUOTE_ACTIONS = [
  'ORDER',
  'REQUEST_REVISION',
  'DECLINE',
  'VIEW_ORDER',
  'PRINT',
  'CANCEL_REQUEST',
] as const;
export type QuoteAction = (typeof QUOTE_ACTIONS)[number];

/**
 * 상태별 고객 응답 버튼(견적 설계 §7-3).
 *
 * ORDERED 의 결제하기·주문 취소·영수증은 내 주문 상세로 옮겼다(주문 설계 §8-4) — 내 견적에는 "주문 보기"와 인쇄만 남긴다.
 */
const ACTIONS_BY_STATUS: Readonly<Record<QuoteRequestStatus, readonly QuoteAction[]>> = {
  REQUESTED: ['CANCEL_REQUEST'],
  ISSUED: ['ORDER', 'REQUEST_REVISION', 'DECLINE', 'PRINT'],
  REVISION_REQUESTED: ['CANCEL_REQUEST'],
  ORDERED: ['VIEW_ORDER', 'PRINT'],
  DECLINED: [],
  REJECTED: [],
  CANCELED: [],
  EXPIRED: ['REQUEST_REVISION'],
};

export const allowedQuoteActions = (status: QuoteRequestStatus): readonly QuoteAction[] =>
  ACTIONS_BY_STATUS[status];
